import React, { useEffect, useState } from 'react';
import { NavigationContainer } from '@react-navigation/native';
import { createDrawerNavigator } from '@react-navigation/drawer';
import { resetData, setData } from "services/redux/data/actions";
import { Image, ScrollView, StyleSheet, useWindowDimensions, View } from "react-native";
import { AppRoutes, MainAppRoutes } from "navigations/app-routes";
import HelperString from "utils/helper-string";
import i18n from "utils/i18n";
import { useDispatch, useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import _ from "lodash";
import Divider from 'theme/Divider';
import Text from "theme/Text";
import HelperSetting from "utils/helper-setting";
import { settingsConstants } from "utils/constants/settings-constants";
import HelperPlatform from "utils/helper-platform";
import UserService from "services/user";
import { colorList } from 'utils/colors'
import HelperManagementRights from "utils/helper-management-rights";
import { managementRightsConstants } from "utils/constants/management-right-constants";
import { filterTabs } from 'navigations/_functions/tabs'
import { resetAuthentication } from 'services/redux/authentication/actions'
import { resetCart } from 'services/redux/cart/actions'
import { navigationContainerProps } from 'utils/helper-navigation-container'
import { resetManagement } from 'services/redux/management/actions'
import ThemedButtonContainer from 'components/atoms/ThemedButtonContainer'
import Button from 'theme/Button'
import { MODES } from 'utils/constants/app-modes';
import { useShowHamburger } from 'utils/helper-device'
import { isManagementDomain } from 'utils/helper-linking'
import IconBackground from 'components/atoms/IconBackground'
import IconWhite from 'assets/icon-white.png';
import HelperVersion from 'utils/helper-version'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import Icon from 'components/atoms/Icon'
import { layoutStyles } from 'styles/layout'
import Translate from 'utils/translate'
import HelperTimeslotKinds from 'utils/helper-timeslot-kinds'
import { bookingConstants } from 'utils/constants/booking-constants'
import IsFocusedToRedux from 'components/atoms/IsFocusedToRedux'
import { createUrl, openUrl } from 'utils/helper-url'
import ThemedPressable from 'components/atoms/ThemedPressable'
import ManagementBookingsNavigator from 'navigations/management/bookings'
import ManagementReportsNavigator from 'navigations/management/reports'
import ManagementEmployeesNavigator from 'navigations/management/employees'
import ManagementCompanyNavigator from 'navigations/management/companies'
import ManagementJobtitlesNavigator from 'navigations/management/jobtitles'
import ManagementBuildingsNavigator from 'navigations/management/buildings'
import ManagementQrcodeNavigator from 'navigations/management/qrcodes'
import ManagementDashboardNavigator from 'navigations/management/dashboard'
import ManagementSettingsNavigator from 'navigations/management/settings'
import ManagementTimeslotsNavigator from 'navigations/management/timeslots'
import ManagementStatisticsNavigator from 'navigations/management/statistics'
import ManagementBookingsValidateNavigator from 'navigations/management/bookings_validate'
import VStack from 'components/atoms/stack/VStack'
import ManagementEmailsNavigator from 'navigations/management/emails'
import ManagementAppMessagesNavigator from 'navigations/management/app_messages'
import ManagementCreditBundlesNavigator from 'navigations/management/credits';

const { Navigator, Screen } = createDrawerNavigator();

const ManagementNavigator = () => {

	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );

	const [ tabs, setTabs ] = useState( [] )

	const createTabs = () => {
		const iconProps = {
			size: 20,
			style: styles.icon,
			color: "black"
		};

		const tabs = [];
		const bookingSubTabs = [];
		const companySubTabs = [];
		const buildingSubTabs = [];

		// -------------------------------------------------------------------------------------------
		// Create the booking items sub-tabs
		// -------------------------------------------------------------------------------------------
		_.forEach( _timeslotKinds, ( timeslotKind ) => {
			const name = Translate.field( timeslotKind, 'name' );
			const isCustom = timeslotKind.kind === bookingConstants.CUSTOM;

			// Validate?
			switch( timeslotKind.kind ) {
				case bookingConstants.BOOKING:
					if( !HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.BOOKINGS_WORKPLACES ) ) {
						return true;
					}
					break;

				case bookingConstants.MEETING_ROOM:
					if( !HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.BOOKINGS_MEETING_ROOMS ) ) {
						return true;
					}
					break;

				case bookingConstants.LUNCH:
					if( !HelperSetting.isYes( settingsConstants.BOOKING_ENABLE_LUNCH ) || !HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.BOOKINGS_LUNCH ) ) {
						return true;
					}
					break;

				case bookingConstants.TRANSPORT:
					if( !HelperSetting.isYes( settingsConstants.BOOKING_ENABLE_PARKING ) || !HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.BOOKINGS_PARKING_SPOTS ) ) {
						return true;
					}
					break;
			}

			if( isCustom || timeslotKind.kind === timeslotKind.sub_kind ) {
				bookingSubTabs.push( {
					name: HelperTimeslotKinds.managementRouteName( timeslotKind ),
					title: name,
					icon: (
						<Icon icon={ timeslotKind.icon } { ...iconProps } />
					),
					component: ManagementBookingsNavigator,
					webCompatible: true,
					padCompatible: true,
					phoneCompatible: true
				} );
			}
		});

		//
		if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.BOOKINGS_WORKPLACES ) ) {
			bookingSubTabs.push({
				name: AppRoutes.MANAGEMENT_BOOKINGS_ERO,
				title: i18n.t( 'management:menu.ero' ),
				icon: (
					<Icon icon={ IconSystemConstants.ERO } { ...iconProps } />
				),
				component: ManagementBookingsNavigator,
				webCompatible: true,
				padCompatible: true,
				phoneCompatible: false,
			});
		}
		
		bookingSubTabs.push({
			name: AppRoutes.MANAGEMENT_BOOKINGS_VALIDATE,
			title: i18n.t( 'management:menu.bookings_validate' ),
			icon: (
				<Icon icon={ IconSystemConstants.USER_CHECK } { ...iconProps } />
			),
			component: ManagementBookingsValidateNavigator,
			webCompatible: true,
			padCompatible: true,
			phoneCompatible: true,
		});

		//
		if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.BOOKINGS_REPORTS ) ) {
			bookingSubTabs.push({
				name: AppRoutes.MANAGEMENT_REPORTS,
				title: i18n.t( 'management:menu.reports' ),
				icon: (
					<Icon icon={ IconSystemConstants.REPORT } { ...iconProps } />
				),
				component: ManagementReportsNavigator,
				webCompatible: true,
				padCompatible: true,
				phoneCompatible: false,
			});
		}

		// -------------------------------------------------------------------------------------------
		// Create the company sub-tabs
		// -------------------------------------------------------------------------------------------
		if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.TEAMS ) ) {
			companySubTabs.push({
				name: AppRoutes.MANAGEMENT_EMPLOYEES_TEAMS,
				title: i18n.t( 'management:menu.teams' ),
				icon: (
					<Icon icon={ IconSystemConstants.PERSON } { ...iconProps } />
				),
				component: ManagementEmployeesNavigator,
				webCompatible: true,
				padCompatible: true,
				phoneCompatible: true,
			});
		}

		if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.COMPANIES ) ) {
			companySubTabs.push( {
				name: AppRoutes.MANAGEMENT_COMPANY_COMPANIES,
				title: i18n.t( 'management:menu.companies' ),
				icon: (
					<Icon icon={ IconSystemConstants.WORK } { ...iconProps } />
				),
				component: ManagementCompanyNavigator,
				webCompatible: true,
				padCompatible: true,
				phoneCompatible: true,
			} );
		}

		if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.JOBTITLES ) ) {
			companySubTabs.push({
				name: AppRoutes.MANAGEMENT_JOBTITLES_JOBTITLES,
				title: i18n.t( 'management:menu.jobtitles' ),
				icon: (
					<Icon icon={ IconSystemConstants.WORK } { ...iconProps } />
				),
				component: ManagementJobtitlesNavigator,
				webCompatible: true,
				padCompatible: true,
				phoneCompatible: true,
			});
		}

		// -------------------------------------------------------------------------------------------
		// Create the building sub-tabs
		// -------------------------------------------------------------------------------------------
		if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.BUILDINGS ) ) {
			buildingSubTabs.push({
				name: AppRoutes.MANAGEMENT_BUILDINGS_BUILDINGS,
				title: i18n.t( 'management:menu.buildings' ),
				icon: (
					<Icon icon={ IconSystemConstants.BUILDING } { ...iconProps } />
				),
				component: ManagementBuildingsNavigator,
				webCompatible: true,
				padCompatible: true,
				phoneCompatible: true,
			});
		}

		if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.QR_CODES ) ) {
			buildingSubTabs.push({
				name: AppRoutes.MANAGEMENT_QRCODES,
				title: i18n.t( 'management:menu.qrcodes' ),
				icon: (
					<Icon icon={ IconSystemConstants.QRCODE } { ...iconProps } />
				),
				component: ManagementQrcodeNavigator,
				webCompatible: true,
				padCompatible: true,
				phoneCompatible: true,
			});
		}

		// -------------------------------------------------------------------------------------------
		// Create the tabs
		// -------------------------------------------------------------------------------------------
		if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.DASHBOARD  ) ) {
			tabs.push( {
				title: i18n.t( 'management:menu.dashboard' ),
				items: [
					{
						name: AppRoutes.MANAGEMENT_DASHBOARD_GROUP,
						title: i18n.t( 'management:menu.dashboard' ),
						icon: (
							<Icon icon={ IconSystemConstants.PERSON } { ...iconProps } />
						),
						component: ManagementDashboardNavigator,
						webCompatible: true,
						padCompatible: true,
						phoneCompatible: true
					}
				]
			} );
		}

		if( bookingSubTabs.length > 0 ) {
			tabs.push({
				title: i18n.t( 'management:menu.bookings' ),
				icon: (
					<Icon icon={ IconSystemConstants.CALENDAR_PLUS } { ...iconProps } />
				),
				items: bookingSubTabs
			});
		}

		if( companySubTabs.length > 0 ) {
			tabs.push({
				title: i18n.t( 'management:menu.company' ),
				icon: (
					<Icon icon={ IconSystemConstants.PERSON } { ...iconProps } />
				),
				items: companySubTabs
			});
		}

		if( buildingSubTabs.length > 0 ) {
			tabs.push( {
				title: i18n.t( 'management:menu.buildings' ),
				icon: (
					<Icon icon={ IconSystemConstants.BUILDING } { ...iconProps } />
				),
				items: buildingSubTabs
			});
		}

		if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.STATISTICS ) ) {
			tabs.push({
				title: i18n.t( 'management:pages.statistics.index.title' ),
				items: [
					{
						name: AppRoutes.MANAGEMENT_STATISTICS,
						title: i18n.t( 'management:menu.statistics' ),
						icon: (
							<Icon icon={ IconSystemConstants.CHART } { ...iconProps } />
						),
						component: ManagementStatisticsNavigator,
						webCompatible: true,
						padCompatible: true,
						phoneCompatible: true,
					},
				]
			});
		}

		if( HelperManagementRights.hasViewRight( managementRightsConstants.VIEW.SETTINGS ) ) {
			let settingItems = [
				{
					name: AppRoutes.MANAGEMENT_SETTINGS_APP,
					title: i18n.t( 'management:menu.settings' ),
					icon: (
						<Icon icon={ IconSystemConstants.USER_SETTINGS }	{...iconProps} />
					),
					component: ManagementSettingsNavigator,
					webCompatible: true,
					padCompatible: true,
					phoneCompatible: true,
				},
			];

			if( HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.TIMESLOTS ) ) {
				settingItems.push(
					{
						name: AppRoutes.MANAGEMENT_TIMESLOTS,
						title: i18n.t( 'management:menu.timeslots' ),
						icon: (
							<Icon icon={ IconSystemConstants.CLOCK } { ...iconProps } />
						),
						component: ManagementTimeslotsNavigator,
						webCompatible: true,
						padCompatible: true,
						phoneCompatible: true,
					}
				);
			}

			if( HelperSetting.isYes( settingsConstants.CREDITS_ENABLED ) && HelperManagementRights.hasEditRight( managementRightsConstants.EDIT.CREDITS ) ) {
				settingItems.push(
					{
						name: AppRoutes.MANAGEMENT_CREDIT_BUNDLES,
						title: i18n.t( 'management:menu.credits' ),
						icon: (
							<Icon icon={ IconSystemConstants.PAY } { ...iconProps } />
						),
						component: ManagementCreditBundlesNavigator,
						webCompatible: true,
						padCompatible: true,
						phoneCompatible: true,
					}
				);
			}
			
			settingItems.push( {
				name: AppRoutes.MANAGEMENT_SETTINGS_EMAILS,
				title: i18n.t( 'management:menu.emails' ),
				icon: (
					<Icon icon={ IconSystemConstants.EMAIL } {...iconProps} />
				),
				component: ManagementEmailsNavigator,
				webCompatible: true,
				padCompatible: true,
				phoneCompatible: true,
			})
			
			settingItems.push( {
				name: AppRoutes.MANAGEMENT_APP_MESSAGES,
				title: i18n.t( 'management:menu.app_messages' ),
				icon: (
					<Icon icon={ IconSystemConstants.EMAIL } {...iconProps} />
				),
				component: ManagementAppMessagesNavigator,
				webCompatible: true,
				padCompatible: true,
				phoneCompatible: true,
			})

			tabs.push({
				title: i18n.t( 'management:menu.advanced' ),
				icon: (
					<Icon icon={ IconSystemConstants.SETTINGS }	{...iconProps} />
				),
				items: settingItems
			});
		}

		return tabs;
	}

	const prefix = createUrl( MainAppRoutes.MANAGEMENT );

	useEffect( () => {
		// Set the rights
		HelperManagementRights.setEmployee( _employee, true );

		// Create the tabs
		setTabs( createTabs() )
	}, [ _employee, _timeslotKinds ] )

	return (
		<NavigationContainer
			{ ...navigationContainerProps }
			linking={{
				prefixes: [
					prefix
				]
			}}>

			{ _.size( tabs ) > 0 && (
				<DrawerNavigator
					tabs={ tabs }
				/>
			)}
		</NavigationContainer>
	);
}

const DrawerHeader = () => {

	return (
		<VStack>
			<IconBackground
				opacity={ 0.3 }
				style={ styles.header }>

				<Image
					style={ styles.headerImage }
					resizeMode="contain"
					source={ IconWhite }
				/>

				<Text
					style={ styles.headerCompanyName }>

					{ HelperSetting.get( settingsConstants.COMPANY_NAME, null ) }
				</Text>

				<IsFocusedToRedux></IsFocusedToRedux>
				<Text
					style={ styles.versionName }>

					{ HelperVersion.get() }
				</Text>
			</IconBackground>

			<Divider/>
		</VStack>
	);
}

const DrawerFooter = () => {
	const dispatch = useDispatch()
	const domainIsManagement = isManagementDomain()
	const insets = useSafeAreaInsets();

	const setScheduleMode = () => {
		dispatch( setData( dataConstants.MODE, MODES.SCHEDULE ) );

		if( HelperPlatform.isWeb() ) {
			openUrl( createUrl( `` ) )
		}
	}

	const onLogout = () => {
		UserService.logout({
			restart: true,
			resetData: () => {
				return dispatch(resetData());
			},
			resetManagement: () => {
				return dispatch(resetManagement());
			},
			resetAuthentication: () => {
				return dispatch(resetAuthentication());
			},
			resetCart: () => {
				return dispatch(resetCart());
			},
		});
	}

	const buttons = [];
	if( domainIsManagement ) {
		buttons.push(
			<Button
				key={ HelperString.hash( 'button-logout' ) }
				style={ layoutStyles.flexOne }
				onPress={ onLogout }>

				{ i18n.t( 'buttons.logout' ) }
			</Button>
		)
	}

	if( !domainIsManagement ) {
		buttons.push(
			<Button
				key={ HelperString.hash('button-change_to_app') }
				style={ layoutStyles.flexOne }
				onPress={ setScheduleMode }>

				{ i18n.t( 'buttons.change_to_app' ) }
			</Button>
		)
	}

	return (
		<View
			style={ styles.viewJustifyContentFlexEndWidth100 }>

			<ThemedButtonContainer
				fill={ buttons.length === 1 }
				style={ {
					paddingBottom: (insets?.bottom ?? 0) + 5
				} }>

				{ buttons }
			</ThemedButtonContainer>
		</View>
	)
}

const DrawerAccessories = ( { tabs = {}, navigation, state } ) => {
	const _settings = useSelector( state => {
		return state.data[dataConstants.SETTINGS];
	} )
	const { height } = useWindowDimensions()

	const onPressDrawerItem = ( tab ) => {
		navigation.reset({
			index: 0,
			routes: [
				{
					name: tab.name,
				}
			]
		})
	}

	return (
		<View
			style={{
				flex: 1,
				height: height,
				maxHeight: height,
			}}>

			{/* Header */}
			<View>
				<DrawerHeader />
			</View>

			{/*	Content */}
			<ScrollView>
				<>
					{ _.map( tabs, tabGroup => {
						// Filter the items
						const tabItems = filterTabs( tabGroup.items, _settings )
	
						// Create the sub items
						const items = _.map( tabItems, ( tab ) => {
							const isBottomTab = _.get( tab, 'title', false );
							if ( !isBottomTab ) {
								return ( <></> );
							}
	
							return (
								<DrawerItem
									key={ HelperString.hash( 'drawer-item', tab.title )}
									onPress={ onPressDrawerItem.bind( this, tab ) }
									icon={ tab.icon }>
	
									{ tab.title }
								</DrawerItem>
							)
						} )
	
						if( items.length === 0 ) {
							return <></>;
						}
	
						if( items.length === 1 ) {
							return (
								<View
									key={ HelperString.hash( 'drawer-item', tabGroup.title  ) }
									style={styles.viewBorderBottomWidth1BorderColorLight}>
	
									{ items }
								</View>
							);
						}
	
						// Grab the first tab item
						const tabGroupTabFirst = _.first( tabItems )
	
						return (
							<View
								key={ HelperString.hash( 'ManagementNavigator-DrawerGroup', tabGroup.title  ) }
								style={styles.viewBorderBottomWidth1BorderColorLight}>
	
								<DrawerItem
									onPress={ onPressDrawerItem.bind( this, tabGroupTabFirst ) }
									icon={ tabGroup.icon }>
	
									{ tabGroup.title }
								</DrawerItem>
	
								<View
									style={styles.viewPaddingLeft8}>
	
									{ items }
								</View>
							</View>
						)
					})}
					
					{/* Footer */}
					<DrawerFooter />
				</>
			</ScrollView>
		</View>
	)
};

const DrawerItem = ({ icon, onPress, children }) => {

	return (
		<ThemedPressable
			onPress={ onPress }>

			<View
				style={styles.viewFlexDirectionRowAlignItemsCenter}>

				{ icon && (
					<View
						style={styles.viewMarginRight8}>

						{ icon }
					</View>
				)}

				<Text
					style={styles.textFontWeightBoldFontSize12}
					numberOfLines={1}>

					{ children }
				</Text>
			</View>
		</ThemedPressable>
	)
}

const DrawerNavigator = ( { tabs = {}, settings = {} }) => {
	const showHamburger = useShowHamburger()
	const _settings = useSelector( state => {
		return state.data[dataConstants.SETTINGS];
	} )

	let screenOptions = {
		drawerType: 'front',

		// Hide the title and icon
		title: null,
		headerLeft: () => {
			return null;
		},

		// To not show the 'default' header
		headerBackgroundContainerStyle: {
			height: 0,
		},
		headerStyle: {
			height: 0,
		}
	}

	if( HelperPlatform.isWeb() ) {
		screenOptions = {
			drawerType: !showHamburger ? 'permanent' : 'front',

			// Hide the title and icon
			title: null,
			headerLeft: () => {
				return null;
			},

			// To not show the 'default' header
			headerBackgroundContainerStyle: {
				height: 0,
			},
			headerStyle: {
				height: 0,
			}
		}
	}

	return (
		<Navigator
			screenOptions={ screenOptions }
			drawerContent={( props) => {
				return (
					<DrawerAccessories
						{ ...props }
						tabs={ tabs }
					/>
				)
			}}>

			{ _.map( tabs, tabGroup => {
				return _.map( filterTabs( tabGroup.items, _settings ), ( tab ) => {
					const isBottomTab = _.get( tab, 'title', false );
					const component = _.get( tab, 'component', false );
					if ( !isBottomTab || !component ) {
						return (<></>);
					}

					return (
						<Screen
							key={ HelperString.hash( 'ManagementNavigator-Screen', tab) }
							name={ tab.name }
							component={ tab.component }
							options={{ title: tab.title }}
						/>
					)
				});
			})}
		</Navigator>
	);
}

const styles = StyleSheet.create({
	viewJustifyContentFlexEndWidth100: {
		justifyContent: 'flex-end',
		width: '100%',
	},
	viewBorderBottomWidth1BorderColorLight: {
		borderBottomWidth: 1,
		borderColor: colorList.GREY.light,
	},
	viewPaddingLeft8: {
		paddingLeft: 8,
	},
	viewFlexDirectionRowAlignItemsCenter: {
		flexDirection: 'row',
		alignItems: 'center',
		paddingVertical: 12,
		paddingHorizontal: 8,
	},
	viewMarginRight8: {
		marginRight: 8,
	},
	textFontWeightBoldFontSize12: {
		fontWeight: 'bold',
		fontSize: 12,
	},
	header: {
		width: '100%',
		minHeight: 140,
		backgroundColor: colorList.PRIMARY.primary
	},
	headerImage: {
		width: '100%',
		height: 120
	},
	headerCompanyName: {
		textAlign: 'center',
		width: '100%',
		color: colorList.WHITE.primary,
	},
	versionName: {
		textAlign: 'center',
		width: '100%',
		color: colorList.WHITE.primary,
		paddingBottom: 8,
		fontSize: 10
	},
	logOutButton: {
		position: 'absolute',
		right: 10,
		bottom: 10,
	},
	icon: {
		width: 20,
		height: 20,
		opacity: 0.5
	}
});

export default ManagementNavigator
